<template>
  <div class="rt-lookup" style="display:block">
    <el-input readonly :disabled="disabled" v-model="lookupValue.name">
      <i
        slot="suffix"
        class="el-input__icon el-icon-search"
        @click="showLookupDialog"
      ></i>
    </el-input>
    <rt-lookup-dialog
      ref="lookupDialog"
      :entity="entity"
      :request-url="dialogRequestUrl"
      :name-field="nameField"
      :id-field="idField"
      :display-fields="dialogDisplayFields"
      :orderby-fields="dialogOrderbyFields"
      :custom-conditions="dialogCustomConditions"
      :filter-fields="dialogFilterFields"
      :return-fields="dialogReturnFields"
      @data-selected="handleDataSelected"
    >
    </rt-lookup-dialog>
  </div>
</template>

<script>
import RtLookupDialog from "./lookup-dialog";

export default {
  name: "RtLookup",
  props: {
    value: {
      type: Object,
      required: false,
    },
    disabled: Boolean,
    entity: {
      type: String,
      required: true,
    },
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    dialogCustomConditions: String,
    dialogReturnFields: String,
  },
  components: {
    "rt-lookup-dialog": RtLookupDialog,
  },
  computed: {},
  data() {
    return {
      lookupValue: {},
    };
  },
  watch: {
    value(newValue) {
      this.lookupValue = newValue || {};
    },
  },
  mounted() {
    if (this.value) {
      this.lookupValue = this.value;
    }
  },
  methods: {
    showLookupDialog() {
      if (this.disabled) {
        return;
      }

      this.$refs.lookupDialog.show();
    },
    handleDataSelected(val) {
      this.lookupValue = val;
      this.$emit("input", val);

      this.$emit("change", val);
    },
  },
};
</script>



// WEBPACK FOOTER //
// lookup.vue?0629fb3f